export default __webpack_public_path__ + "static/media/hood-preview.bc286287.png";